import { Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EmptyTableContent } from '@hero/components/molecules/EmptyTableContent';

import * as S from './style';

function CustomRemoveContactEmptyTable({ table }) {
  const { t } = useTranslation();
  const searchTerm = table.getState().globalFilters?.searchTerm;

  if (searchTerm) {
    return <EmptyTableContent />;
  }

  return (
    <S.CustomRemoveEmptyTableWrapper>
      <Typography variant="body2" color="fg" emphasis="weaker" style={{ margin: '30% 20% auto' }}>
        {t('addRecipientEmptyTable')}
      </Typography>
    </S.CustomRemoveEmptyTableWrapper>
  );
}

export { CustomRemoveContactEmptyTable };
